import { store } from "@irati/store";
import { get } from "lodash";
import { DEFAULT_LANG } from "../getSupportedLocale";
export default function getCurrentLocale() {
    return get(store.getState(), "lang.currentLocale", DEFAULT_LANG);
}
